import { Facebook, Instagram, Twitter } from "lucide-react";
import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
export const Footer = () => {
  const isMobile = useIsMobile();
  if (isMobile) {
    return null;
  }
  return;
};